<script setup>
import { computed } from 'vue';
import ExteriorSectionJP from './ExteriorSectionJP';

import { useMainStore } from '@/store/index.js';
const store = useMainStore();

const emit = defineEmits(['select', 'update:modelValue']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  offerTemplate: {
    type: String,
    default: '',
    required: true,
  },
  specType: {
    type: String,
    default: '',
    required: true,
  },
  isFrameAgreement: {
    type: Boolean,
    default: false,
    required: true,
  },
  chassisDescriptionKey: {
    type: String,
    required: false,
    default: '',
  },
  isBev: {
    type: Boolean,
    default: false,
  },
  isRigid: {
    type: Boolean,
    default: false,
  },
  isTractor: {
    type: Boolean,
    default: false,
  },
  showDimensionsSubheader: {
    type: Boolean,
    default: true,
  },
});

const isSpecEB = computed(() => {
  return props.offerTemplate === `${String(store.market).toUpperCase()}_STANDARDA4X2EB`;
});

const checkIfBodyBuildSectionFrameAgreement = computed(() => {
  return props.isFrameAgreement;
});

const checkIfBodyBuildSectionStockVehicle = computed(() => {
  return props.specType === 'stock_vehicle';
});

const checkIfBodyBuildSectionStandard = computed(() => {
  return props.specType !== 'stock_vehicle' && !props.isBev;
});

const checkIfBodyBuildSectionStandardBev = computed(() => {
  return props.isBev;
});

const checkIfBodyBuildSectionRigid = computed(() => {
  return props.isRigid;
});

const checkIfBodyBuildSectionTractor = computed(() => {
  return props.isTractor;
});

const selectedMarket = computed(() => {
  return String(store.market).toUpperCase();
});
</script>

<template>
  <ExteriorSectionJP
    v-if="selectedMarket === 'JP' && (checkIfBodyBuildSectionRigid || checkIfBodyBuildSectionTractor)"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
    :show-dimensions-subheader="props.showDimensionsSubheader"
    @select="emit('select', $event)"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

<style scoped>
</style>
